import _ from "lodash";
import moment from "moment";
import config from '../app/config';

/**
 * Key Performance Indicator Time Markers
 * @param {Object[]} savedObjects - Array of patient modifications to save
 * @param {Object} patient - Patient object
 * @param {string[]} arrFirstSaveOpt - Options to what it should check. [firstInitialAssessment, firstClinicianSaved, firstClinicallyReadyToProceedSaved]
 * @param {Object[]} objToSave - Object to save if it passes checking
 */
const keyPerformanceIndicator = (savedObjects, patient, arrFirstSaveOpt, objToSave) => {
    if (_.isNil(savedObjects)) {
        console.error("[KPI] Array of patient modifications cannot be null.");
        return;
    }
    if (_.isNil(patient)) {
        console.error("[KPI] Patient object cannot be null.");
        return;
    }
    if (_.isEmpty(arrFirstSaveOpt) || !_.isArray(arrFirstSaveOpt)) {
        console.error("[KPI] Options cannot be empty or not be a string.");
        return;
    }
    if (_.isNil(objToSave)) {
        console.error("[KPI] Object to save cannot be null.");
        return;
    } else {
        if (!objToSave.when) {
            console.error("[KPI] Object must have properties when.");
            return;
        }
    }

    if ((config?.disableTimeMarkersOnPastAttendance && _.isNil(patient?.admission?.endDate)) || !config?.disableTimeMarkersOnPastAttendance) {
        const firstInitialAssessment = patient?.metadata?.firstInitialAssessment?.when ? moment(patient?.metadata?.firstInitialAssessment?.when) : null;
        const firstClinicianSaved = patient?.metadata?.firstClinicianSaved?.when ? moment(patient?.metadata?.firstClinicianSaved?.when) : null;
        const firstClinicallyReadyToProceedSaved = patient?.metadata?.firstClinicallyReadyToProceedSaved?.when ? moment(patient?.metadata?.firstClinicallyReadyToProceedSaved?.when) : null;
        const currentTime = moment().toISOString();

        if (arrFirstSaveOpt.includes("firstInitialAssessment")) {
            if (_.isNull(firstInitialAssessment) || firstInitialAssessment.isAfter(objToSave.when)) {
                savedObjects.push({
                    name: "metadata.firstInitialAssessment",
                    value: {
                        when: objToSave.when,
                        who: objToSave.who ? objToSave.who : null,
                        timestamp: currentTime
                    }
                });
            }
        }

        if (arrFirstSaveOpt.includes("firstClinicianSaved")) {
            if (_.isNull(firstClinicianSaved) || firstClinicianSaved.isAfter(objToSave.when)) {
                savedObjects.push({
                    name: "metadata.firstClinicianSaved",
                    value: {
                        when: objToSave.when,
                        who: objToSave.who ? objToSave.who : null,
                        timestamp: currentTime
                    }
                });
            }
        }

        if (arrFirstSaveOpt.includes("firstClinicallyReadyToProceedSaved")) {
            if (_.isNull(firstClinicallyReadyToProceedSaved) || firstClinicallyReadyToProceedSaved.isAfter(objToSave.when)) {
                savedObjects.push({
                    name: "metadata.firstClinicallyReadyToProceedSaved",
                    value: {
                        when: objToSave.when,
                        who: objToSave.who ? objToSave.who : null,
                        timestamp: currentTime
                    }
                });
            }
        }
    } else {
        console.warn('Past Attendance. Key Performance Indicator is not saved');
    }
};

export default keyPerformanceIndicator;